import { createAsyncThunk } from '@reduxjs/toolkit';
//import axios from 'axios';
import api from '../../../api/apiServises';
import {
  FINAL_QC_PARAMS,
  RMPU_CHECKSHEET_PARAMS,
  S3_ROOF_PRECELLING_PARAMS,
  FETCH_UF_FRAME_TYPES,
  ROOF_PRECELLING_STORE,
  ROOF_PRECELLING_LIST,
  ROOF_PRECELLING_UPDATE_FLOW_STATUS,
  ROOF_PRECELLING_HISTORY,
  ROOF_PRECELLING_VIEW,
  FIRE_SAFETY_PARAMS,
  FETCH_MASTER_COACH_NO,
  FINAL_QUALITY_INSPECTION_LIST,
  CREATE_ELE_FINAL_QUALITY_INSPECTION,
  AIR_DELIVERY_DATA_PARAMS,
  GET_ELECTRICAL_INSPECTION_DATA,
  CHANGE_FLOW_STATUS_ELECTRICAL_FINAL_INSPECTION,
  GET_ELECTRICAL_HISTORY,
  GET_SELECTED_ELECTRICAL_HISTORY,
  CREATE_UPDATE_ELECTRICAL_FIRE_SAFETY,
  ELECTRICAL_FIRE_SAFETY_LIST,
  ELECTRICAL_FIRE_SAFETY_GET_HISTORY,
  ELECTRICAL_FIRE_SAFETY_FLOW_STATUS_CHANGE,
  STORE_ELECTRICAL_RMPU_DATA,
  LIST_ELECTRICAL_RMPU_DATA,
  GET_MASTER_COACH_NO,
  LIST_ELECTRICAL_RMPU_DATA_BY_ID,
  DELETE_ELECTRICAL_RMPU_DATA,
  VIEW_ELECTRICAL_RMPU_DATA,
  UPDATE_ALL_ONE_ACTION_LATEST,
  RMPU_ASSEMBLY_FLOW_HISTORY,
  DELETE_ELECTRICAL_DATA,
  ELECTRICAL_DASHBOARD,
  S3_ROOF_PRECELLING_FLOW_HISTORY,
  QFR_PRECELLING_STORE,
  STORE_TRACTION_MOTOR_VB,
  FETCH_TRACTION_MOTOR_VB_LIST,
  VIEW_TRACTION_MOTOR_VB,
  TRACTION_MOTOR_VB_FLOW_HISTORY,
  DELETE_TRACTION_DATA,
  CHECK_ELECTRICAL_RECORD_EXIST,
  CREATE_AIR_DELIVERY,
  FETCH_AIR_DELIVERY_LIST,
  UPDATE_AIR_DELIVERY_FLOW_STATUS ,
  DELETE_AIR_DELIVERY,
  QFR_FINAL_QUALITY_STORE,
} from '../../../api/apiConstant';

// Define API_URL
//const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const fetchEles3params = createAsyncThunk(
  'electrical/fetchEles3params',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(S3_ROOF_PRECELLING_PARAMS);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchEleQcParams = createAsyncThunk(
  'electrical/fetchEleQcParams',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FINAL_QC_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRmpuChecksheetParams = createAsyncThunk(
  'electrical/fetchRmpuChecksheetParams',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(RMPU_CHECKSHEET_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchFrameType = createAsyncThunk(
  'frame/fetchFrameType',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_UF_FRAME_TYPES);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const storeRoofPrecellingData = createAsyncThunk(
  'electrical/storeRoofPrecellingData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ROOF_PRECELLING_STORE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRoofPrecellingList = createAsyncThunk(
  'electrical/fetchRoofPrecellingList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(ROOF_PRECELLING_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const fetchS3RoofPrecellingFlowHistory = createAsyncThunk(
  'electrical/fetchS3RoofPrecellingFlowHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${S3_ROOF_PRECELLING_FLOW_HISTORY}${params.stage_id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const updateRoofPrecellingFlowStatus = createAsyncThunk(
  'electrical/updateRoofPrecellingFlowStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(ROOF_PRECELLING_UPDATE_FLOW_STATUS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRoofPrecellingHistory = createAsyncThunk(
  'electrical/fetchRoofPrecellingHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(ROOF_PRECELLING_HISTORY, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRoofPrecellingViewData = createAsyncThunk(
  'electrical/fetchRoofPrecellingViewData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${ROOF_PRECELLING_VIEW}/${params.id}`);
      return response.data?.data || response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const clearRoofPrecellingHistory = () => {
  return {
    type: 'electrical/clearRoofPrecellingHistory',
  };
};

export const fetchFireSafetyParams = createAsyncThunk(
  'electrical/fetchFireSafetyParams',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(FIRE_SAFETY_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchCoachNo = createAsyncThunk(
  'boggie/fetchCoachNo',
  async (_, { rejectWithValue }) => {
    try {
      const response = await api.get(GET_MASTER_COACH_NO);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const fetchFqaList = createAsyncThunk(
  'electrical/fetchFqaList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FINAL_QUALITY_INSPECTION_LIST, {
        params: {
          page: params.page,
          per_page: params.per_page || params.perPage || params.limit,
          search: params.search,
          flow_status: params.flow_status,
          confirming: params.confirming,
          coach_type: params.coach_type,
          coach_no: params.coach_no,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const createEleFqInspection = createAsyncThunk(
  'electrical/createEleFqInspection',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(CREATE_ELE_FINAL_QUALITY_INSPECTION, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const getElectricalInspectionData = createAsyncThunk(
  'electrical/getElectricalInspectionData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_ELECTRICAL_INSPECTION_DATA}/${params.id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const changeFlowstatusEleFinalInspection = createAsyncThunk(
  'electrical/changeFlowstatusEleFinalInspection',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.post(CHANGE_FLOW_STATUS_ELECTRICAL_FINAL_INSPECTION, {
        ...params,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const getElectricalHistory = createAsyncThunk(
  'electrical/getElectricalHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_ELECTRICAL_HISTORY}/${params.id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const getSelectedElectricalHistory = createAsyncThunk(
  'electrical/getSelectedElectricalHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${GET_SELECTED_ELECTRICAL_HISTORY}/${params.id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const createUpdateEleFinalSafety = createAsyncThunk(
  'electrical/createUpdateEleFinalSafety',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(CREATE_UPDATE_ELECTRICAL_FIRE_SAFETY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const getElectricalFireSafetyList = createAsyncThunk(
  'electrical/getElectricalFireSafetyList',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(ELECTRICAL_FIRE_SAFETY_LIST, {
        params: {
          page: params.page,
          per_page: params.per_page,
          search: params.search,
          flow_status: params.flow_status,
          confirming: params.confirming,
          coach_type: params.coach_type,
          coach_no: params.coach_no,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const getElectricalFireSafetyHistory = createAsyncThunk(
  'electrical/getElectricalFireSafetyHistory',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(`${ELECTRICAL_FIRE_SAFETY_GET_HISTORY}${params.id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something Went Wrong.');
    }
  },
);

export const changeElectricalFireSafetyFlowStatusChange = createAsyncThunk(
  'electrical/changeElectricalFireSafetyFlowStatusChange',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(ELECTRICAL_FIRE_SAFETY_FLOW_STATUS_CHANGE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const fetchAirDeliveryDataParams = createAsyncThunk(
  'electrical/fetchAirDeliveryDataParams',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(AIR_DELIVERY_DATA_PARAMS, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something wents wrong');
    }
  },
);

export const saveRMPUChecksheetData = createAsyncThunk(
  'electrical/saveRMPUChecksheetData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_ELECTRICAL_RMPU_DATA, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRMPUChecksheetData = createAsyncThunk(
  'electrical/fetchRMPUChecksheetData',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(LIST_ELECTRICAL_RMPU_DATA, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch RMPU data');
    }
  },
);

export const fetchRMPUChecksheetStageById = createAsyncThunk(
  'electrical/fetchRMPUChecksheetStageById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(LIST_ELECTRICAL_RMPU_DATA_BY_ID, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const deleteRMPUChecksheet = createAsyncThunk(
  'electrical/deleteRMPUChecksheet',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_ELECTRICAL_RMPU_DATA, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const rmpuInspectionAction = createAsyncThunk(
  'electrical/rmpuInspectionAction',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRMPUChecksheetViewData = createAsyncThunk(
  'electrical/fetchRMPUChecksheetViewData',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_ELECTRICAL_RMPU_DATA, payload);
      return response.data?.data || response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const fetchRMPUFlowHistory = createAsyncThunk(
  'electrical/fetchRMPUFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(RMPU_ASSEMBLY_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const deleteElectricalData = createAsyncThunk(
  'furnishing/deleteElectricalData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_ELECTRICAL_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);

// ========== DASHBOARD ==========

// export const fetchElectricalDashboard = createAsyncThunk(
//   'electrical/fetchElectricalDashboard',
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await api.post(ELECTRICAL_DASHBOARD, {formData});
//       console.log('📊 Initial dashboard response:', response);
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard data');
//     }
//   }
// );

// In electricalThunk.js - Replace the fetchElectricalDashboard function
export const fetchElectricalDashboard = createAsyncThunk(
  'electrical/fetchElectricalDashboard',
  async (params = {}, { rejectWithValue }) => {
    try {
      // Build payload with correct field names
      const payload = {};
      // Handle date range
      if (params?.date_from) {
        payload.date_from = params.date_from;
      }
      if (params?.date_to) {
        payload.date_to = params.date_to;
      }
      
      // Handle single date (for backward compatibility)
      if (params?.date && !params?.date_from) {
        payload.date_from = params.date;
        payload.date_to = params.date;
      }
      
      if (params?.shift) {
        payload.shift = params.shift;
      }
      
      if (params?.shellType) {
        payload.shell_type = params.shellType;
      }
      
      const response = await api.post(ELECTRICAL_DASHBOARD, payload);
      return response.data;
    } catch (error) {
      console.error('❌ Dashboard fetch error:', error);
      return rejectWithValue(error.response?.data?.message || 'Failed to fetch dashboard data');
    }
  },
);
// export const fetchCoachNoByFrameType = createAsyncThunk(
//   'furnishing/fetchCoachNoByFrameType',
//   async (params, { rejectWithValue }) => {
//     try {
//       const response = await api.get(FETCH_MASTER_COACH_NO, {
//         params: {
//           frame_type_id: params.frame_type_id,
//         },
//       });
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
//     }
//   },
// );

export const fetchCoachNoByFrameType = createAsyncThunk(
  'furnishing/fetchCoachNoByFrameType',
  async (params, { rejectWithValue }) => {
    try {
      console.log('🔍 Fetching coach numbers with params:', params);

      // Check if params has shell_type or frame_type_id
      const requestParams = {};
      if (params.shell_type) {
        requestParams.frame_type_id = params.shell_type;
      } else if (params.frame_type_id) {
        requestParams.frame_type_id = params.frame_type_id;
      } else if (params.shellType) {
        requestParams.frame_type_id = params.shellType;
      } else {
        requestParams.frame_type_id = params;
      }

      const response = await api.get(FETCH_MASTER_COACH_NO, {
        params: requestParams,
      });
      return response.data;
    } catch (error) {
      console.error('❌ Error fetching coach numbers:', error);
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);
export const addQFRPreCeilingData = createAsyncThunk(
  'electrical/addQFRPreCeilingData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(QFR_PRECELLING_STORE, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message || 'Something went wrong');
    }
  },
);

export const addTractionMotorVB = createAsyncThunk(
  'electrical/addTractionMotorVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(STORE_TRACTION_MOTOR_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save traction motor VB',
      );
    }
  },
);

export const fetchListTractionMotorVB = createAsyncThunk(
  'electrical/fetchListTractionMotorVB',
  async (params, { rejectWithValue }) => {
    try {
      const response = await api.get(FETCH_TRACTION_MOTOR_VB_LIST, { params });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch traction motor VB list',
      );
    }
  },
);

export const fetchTractionMotorVBById = createAsyncThunk(
  'electrical/fetchTractionMotorVBById',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(VIEW_TRACTION_MOTOR_VB, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch traction motor VB details',
      );
    }
  },
);

export const tractionMotorInspectionActionVB = createAsyncThunk(
  'electrical/tractionMotorInspectionActionVB',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_ALL_ONE_ACTION_LATEST, { ...formData });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to update traction motor VB',
      );
    }
  },
);

export const fetchTractionMotorVBFlowHistory = createAsyncThunk(
  'electrical/fetchTractionMotorVBFlowHistory',
  async (id, { rejectWithValue }) => {
    try {
      const response = await api.post(TRACTION_MOTOR_VB_FLOW_HISTORY, { id });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to fetch flow history',
      );
    }
  },
);

export const deleteTractionMotorVB = createAsyncThunk(
  'electrical/deleteTractionMotorVB ',
  async (formData, { rejectWithValue }) => {
    try {
      // console.log(1370,formData);
      const response = await api.post(DELETE_TRACTION_DATA, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || 'Delete Failed');
    }
  },
);
export const checkRecordExist = createAsyncThunk(
  'electrical/checkRecordExist ',
  async (formData, { rejectWithValue }) => {
    try {
      // console.log(1370,formData);
      const response = await api.post(CHECK_ELECTRICAL_RECORD_EXIST, formData);
      return response;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message || ' Failed');
    }
  },
);

export const createAirDelivery = createAsyncThunk(
  'electrical/createAirDelivery',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(CREATE_AIR_DELIVERY, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to create air delivery',
      );
    }
  },
);
export const fetchAirDeliveryList = createAsyncThunk(
  'electrical/fetchAirDeliveryList',
  async (params, { rejectWithValue }) => {
    try {
      
      const response = await api.post(FETCH_AIR_DELIVERY_LIST, {
        page: params.page,
        per_page: params.per_page || params.perPage || 10,
        search: params.search,
        date: params.date,
        shell_type: params.shell_type,
        coach_no: params.coach_no,
        confirming: params.confirming,
        flow_status: params.flow_status,
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to fetch air delivery list',
      );
    }
  },
);

export const addQFRFinalQualityData = createAsyncThunk(
  'electrical/addQFRFinalQualityData',
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post(QFR_FINAL_QUALITY_STORE, formData);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || error.message || 'Failed to save traction motor VB',
      );
    }
  },
);
// Update Air Delivery flow status (freeze/reinspection)
export const updateAirDeliveryFlowStatus = createAsyncThunk(
  'electrical/updateAirDeliveryFlowStatus',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(UPDATE_AIR_DELIVERY_FLOW_STATUS, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to update flow status'
      );
    }
  }
);

export const deleteAirDelivery = createAsyncThunk(
  'electrical/deleteAirDelivery',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await api.post(DELETE_AIR_DELIVERY, payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message ||
          error.response?.data ||
          error.message ||
          'Failed to delete air delivery record'
      );
    }
  }
);